import React from "react";
import AppBarBar from "./components/AppBar";
import AboutUs from "./components/AboutUs";
import Features from "./components/Features";
import Highlights from "./components/Highlights";
import FooterPage from "./components/FooterPage";
import Banner from "./components/Banner";
import Press from "./components/Press"

function HomePage() {
  return (
    <div className="bg-canvas">
      <AppBarBar />
      <Banner />
      <AboutUs />
      <Press />
      <Features />
      <Highlights />
      {/* <Testimonials/> */}
      <FooterPage preFooter={true} />
    </div>
  );
}

export default HomePage;